// extracted by mini-css-extract-plugin
export default {"skeletWrapper":"TournamentsSkelet_skeletWrapper--_4E","skeletItem":"TournamentsSkelet_skeletItem--iQR"};